import CheckoutNav from "../components/checkout-nav";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export default {
    init() {
        var checkout_nav = new CheckoutNav();
    },
    finalize() {
        // remove coupon cookie if Remove clicked
        document.addEventListener("click", function (event) {
            const el = event.target;
            if (el.classList.contains("woocommerce-remove-coupon")) {
                event.preventDefault();
                const coupon = el.dataset.coupon;
                let cookie = getCookie("gp_coupon_from_url");
                cookie = decodeURIComponent(cookie);
                cookie = cookie.split("+").join(" ");
                if (cookie.toUpperCase() == coupon.toUpperCase()) {
                    document.cookie =
                        "gp_coupon_from_url" +
                        "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                }
            }
        });

        // coupon mask functionality
        jQuery('body').on('input', 'input[name="coupon_code_mask"]', function(){
            jQuery('input[name="coupon_code"]').val(jQuery(this).val());
        });

        jQuery('body').on('click', '.apply_coupon_mask', function(){
            jQuery('button[name="apply_coupon"]').click();
            jQuery('input[name="coupon_code_mask"]').val('');
        });

    },
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-checkout.js